// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"style_loaderOverlay__lQ1Ee","loader":"style_loader__NnAFi","spin":"style_spin__Rlokc"};